import { css, html, LitElement, nothing, PropertyValues } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { countries } from './Countries'
import { Country, Dealer, MapSettings } from './Types'
import { translate } from '../Shared/Translations'

@customElement('lindberg-dealers-list')
export class DealerList extends LitElement {
	static styles = css`
        :host {
            display: block;
            background-color: #f6f2eb;            
            font-family: var(--font-family);


        }
        ::-webkit-scrollbar {
            width: 0px;
        }

        h1 {
            margin: var(--space-200) var(--space-400);
            font-weight: var(--font-weight-medium);
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }

        li {
            padding: 8px var(--space-400);
            border-bottom: 1px solid #eee;
            white-space: nowrap;
            overflow: hidden;
            text-overflow:ellipsis;
            pointer: cursor;

            &:hover {
                background: white;
            }
            &[selected]{                
                background: var(--color-primary-sand-500);
                font-weight: var(--font-weight-medium);


            }
        }
    `

	@property({ type: Array })
	dealers: Dealer[] = []

	@property({ type: Object })
	selectedDealer: Dealer | null = null

	@property({ attribute: false })
	selectedCountry?: Country

	@property({ attribute: false }  )
	settings?: MapSettings


    private _handleKeyDown(e: KeyboardEvent, dealer: Dealer) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this._handleClick(dealer);
        }
    } 
    
    private _handleClick(dealer:Dealer) {
        this.dispatchEvent(new CustomEvent('dealer-selected', { bubbles: true, detail: { dealer } }))
    }

	render() {
        const language = (this.settings?.language || "en").toLowerCase()
        const displayNames = new Intl.DisplayNames([language, "en"], { type: "region", });

		return html`
            ${this.selectedCountry ? html`<h1>${translate('top-dealers', { country: displayNames.of(this.selectedCountry.code) ?? this.selectedCountry.name }, language)}</h1>` : nothing}
            <ul>
                ${this.dealers.map((dealer) => html`
                    <li tabindex="1" role="option" @keydown=${(e: KeyboardEvent) => this._handleKeyDown(e, dealer)} @click=${() => this._handleClick(dealer)} ?selected=${dealer === this.selectedDealer} data-text=${dealer.properties.nameNative && dealer.properties.languageCode.toLowerCase() == language ?  dealer.properties.nameNative : dealer.properties.name}>
                        ${dealer.properties.nameNative && dealer.properties.languageCode.toLowerCase() == language ?  dealer.properties.nameNative : dealer.properties.name}
                    </li>`)} 
            </ul>
        `
	}

	protected override updated(changedProperties:PropertyValues): void {
        super.updated(changedProperties)
        if(this.settings?.screenSize == "large") {
            this.shadowRoot!.querySelector('[selected]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        } else if(changedProperties.has('selectedDealer')){
            document.scrollingElement?.scrollTo({top: 0, behavior: 'smooth'})
        }
	}
}
declare global {
	interface HTMLElementTagNameMap {
		'lindberg-dealers-list': DealerList
	}
}
